var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-table',{attrs:{"columns":_vm.columns,"data-source":_vm.dataSource,"pagination":_vm.ipagination,"loading":_vm.loading,"rowKey":"id"},on:{"change":_vm.handleTableChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }